export default __webpack_public_path__ + "static/media/addbutton.48f04b57.svg";